import { fetcher } from '@commenda/utils';

export interface UnlinkAdminPylonAccountParams {
  companyId: number;
}

export interface UnlinkAdminPylonAccountResponse {
  success: boolean;
}

export async function unlinkAdminPylonAccount({
  companyId,
}: UnlinkAdminPylonAccountParams): Promise<UnlinkAdminPylonAccountResponse> {
  const response = await fetcher(
    `admin/companies/${companyId}/external-connections/pylon`,
    { method: 'DELETE' }
  );

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as {
      message?: unknown;
      error?: unknown;
    } | null;
    const message =
      typeof body?.message === 'string'
        ? body.message
        : Array.isArray(body?.message)
          ? body.message.join(', ')
          : typeof body?.error === 'string'
            ? body.error
            : 'Failed to unlink Pylon account';
    throw new Error(message);
  }

  return response.json();
}
